import { getAnalysisSubtitle } from '@modules/analysis/helpers';
import { INITIAL_ANALYSIS } from '@modules/analysis/store/constants';
import { AnalysisStoreOptions } from '@modules/analysis/store/types';
import { AnalysisUseCase, Scope } from 'generated/graphql';
import {
  getAnalysisLink,
  getAnalysisRoute,
} from 'v2/core/services/analysis/link';
import { StoreApi } from 'zustand';

export const getAnalysisInitialState = (
  set: StoreApi<AnalysisStoreOptions>['setState'],
  useCase: AnalysisUseCase,
) => ({
  ...INITIAL_ANALYSIS,
  metadata: useCase === AnalysisUseCase.Feed ? window.location.href : '{}',
  useCase,
  title: useCase === AnalysisUseCase.Feed ? 'New Feed' : 'New Quantify',
  setAnalysis: (analysis: Partial<AnalysisStoreOptions>) =>
    set((state) => ({
      ...state,
      ...analysis,
    })),
  resetToEmptyAnalysis: () =>
    set((state) => ({
      ...INITIAL_ANALYSIS,
      useCase: state.useCase,
      metadata: useCase === AnalysisUseCase.Feed ? window.location.href : '{}',
      title: useCase === AnalysisUseCase.Feed ? 'New Feed' : 'New Quantify',
    })),
  onRenameAnalysis: (name: string, tenantSlug?: string) =>
    set((state) => ({
      title: name,
      href: getAnalysisLink({
        name: name,
        token: state.viewToken,
        tenantSlug,
        useCase: state.useCase,
      }),
      path: getAnalysisRoute({
        name: name,
        token: state.viewToken,
        useCase: state.useCase,
      }),
      subtitle: getAnalysisSubtitle({
        userName: `${state.createdBy.firstName} ${state.createdBy.lastName}`,
        updatedAt: Math.floor(Date.now() / 1000),
      }),
    })),
  onScopeChange: (scope: Scope) =>
    set((state) => ({
      scope,
      subtitle: getAnalysisSubtitle({
        userName: `${state.createdBy.firstName} ${state.createdBy.lastName}`,
        updatedAt: Math.floor(Date.now() / 1000),
      }),
    })),
  onUpdate: (metadata?: string) =>
    set((state) => ({
      subtitle: getAnalysisSubtitle({
        userName: `${state.createdBy.firstName} ${state.createdBy.lastName}`,
        updatedAt: Math.floor(Date.now() / 1000),
      }),
      metadata,
    })),
});
